import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: '../../../../assets/logo.svg',
  styleUrls: ['./logo.component.css']
})
export class LogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
